import React from 'react'
import '../../css/component/freeLecture/FreeLectureItemList.css'

class FreeLectureItemList extends React.Component {
    immediatelyLearn(lecture_id) {
        window.location.assign(`${window.location.origin}/lecture/${lecture_id}?inviter_id=43611144&st=index_free`)
    }

    render() {
        const {content} = this.props
        return (
            <div className="freeLecture-list-item" onClick={this.immediatelyLearn.bind(this,content.id)}>
                <div className="freeLecture-item-wrap">
                      <div className="freeLecture-item-cover" >
                          <img src={content.cover_url} alt=""/>
                      </div>

                    <div className="list-right-content">
                        <div className="content-title">{content.name}</div>

                        <div className="let-listen-lecture">立即听课</div>
                    </div>
                    {
                        this.props.index + 1 !== this.props.maxlLength && <span className="border-line-bottom"></span>
                    }

                </div>
            </div>
        )
    }
}

export default FreeLectureItemList


// WEBPACK FOOTER //
// ./src/components/freeLecture/FreeLectureItemList.js